module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAMFBMVEVHcEzrvI/qvY/pu47quI/rvY/qvI/qvI/pu47ouo/qvI/rvI/qvI/HlGnBjWHeroI+ya4zAAAADHRSTlMA799UEob2zzwlaKfWw/MfAAAA6ElEQVQ4y83UMQ6CMBQGYEgxQeMgcTGRydmh3oCF3YHJG5hwBAa8AZOziwdwd1AGOvifQU8gnkBjq6ZQeYwmvqn5v7y2PJJa1t8W81GrI9dgw6iBhr4JhxrkE11TA6puue8voZu1wHrZAvsTDd24yAhwtjtgvAga0AEeN2DeADdGWaJIm2escL5iRBzu4n5BSoCjJh6QHbKojh5Egg0BTHCWcOrL5f7Oz3+Um9LAEsEpYAkgiOuq/CVfoPIiVmLCcCrzKJSSzwyAyi1LCb5A5R8x4Bi9l6FfB1vnL6nGwLyoGkno8f99FJ6vSMANpzPY2AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine/center_vip_pri_ic_soi.png
// module id = mzb5
// module chunks = 1